<template>
  <div class="panel margin--bottom granary-right-panel">
    <bar-card :bg="'border-new'">
      <!-- <g-title :bg="'czqs'">农业气象变化趋势</g-title> -->
      <div class="content">
        <div class="chart-box">
          <div ref="chart" class="chart"></div>
        </div>
      </div>
    </bar-card>
  </div>
</template>

<script>
// import gTitle from "../../components/gTitle";
import { loadChart } from "./charts/qxData";
// import { getDpPagePanel } from "@/api/granary";
import { getDpDataItemByCode } from "@/api/granary";
import { timerMixin } from "@/util/mixin/timerMixin";
export default {
  mixins: [timerMixin],
  // components: { gTitle },
  data() {
    return {
      typeList: [
        "温度",
        "年降雨量",
        "年降雨日数",
        "年平均相对湿度",
        "年日照时数"
      ],
      active: 0,
      selectName: "温度"
    };
  },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart);
    this.getData();
  },
  methods: {
    getData() {
      if (!this.chart) {
        this.chart = this.$echarts.init(this.$refs.chart);
      }
      getDpDataItemByCode({ pagePanelCode: "nlmyyfzgk" }).then(res => {
        if (res) {
          let nameList = [];
          let dataList = [];
          res.forEach(ele => {
            let index = this.findIndexByName(ele.series, nameList);
            if (index > -1) {
              dataList[index].data.push(ele);
            } else {
              nameList.push(ele.series);
              let obj = {
                name: ele.series,
                data: [ele]
              };
              dataList.push(obj);
            }
          });

          let zczList = []; //农林牧渔业总产值
          let zjzList = []; //农林牧渔业增加值（亿元）
          let zczsjzsList = []; //农林牧渔业总产值实际增速
          let zjsjzsList = []; //农林牧渔业增加实际增速
          dataList.forEach(ele => {
            if (ele.name === "农林牧渔业总产值") {
              zczList = ele.data.map(item => {
                return Number(item.value);
              });
            }

            if (ele.name === "农林牧渔业增加值（亿元）") {
              zjzList = ele.data.map(item => {
                return Number(item.value);
              });
            }

            if (ele.name === "农林牧渔业总产值实际增速") {
              zczsjzsList = ele.data.map(item => {
                return Number(item.value);
              });
            }

            if (ele.name === "农林牧渔业增加实际增速") {
              zjsjzsList = ele.data.map(item => {
                return Number(item.value);
              });
            }

            let xData = [
              "农林牧渔业总产值（亿元）",
              "农林牧渔业增加值（亿元）",
              "农林牧渔业总产值实际增速",
              "农林牧渔业增加实际增速"
            ];
            let yearList = dataList[0].data.map(ele => {
              return ele.item_name;
            });
            let yData = [zczList, zjzList, zczsjzsList, zjsjzsList];
            loadChart(this.chart, yData, xData, yearList);
          });
        }
      });
    },
    findIndexByName(name, arr) {
      let index = -1;
      arr.some((ele, i) => {
        if (ele === name) {
          index = i;
          return true;
        }
      });
      return index;
    }
    // // 静态数据
    // getData() {
    //   this.chart = this.$echarts.init(this.$refs.chart);
    //   let xData = [
    //     "农林牧渔业总产值（亿元）",
    //     "农林牧渔业增加值（亿元）",
    //     "农林牧渔业总产值实际增速",
    //     "农林牧渔业增加实际增速"
    //   ];
    //   let yearList = ["2015", "2016", "2017", "2018", "2019", "2020"];
    //   let yData = [
    //     [618.31, 694.83, 743.84, 773.49, 914.44, 1038.5],
    //     [396.45, 446.42, 478.96, 500.16, 596.14, 659.82],
    //     [4.1, 3.9, 3.4, 5.0, 2.7, 5.4],
    //     [4.1, 4.2, 3.8, 5.3, 3.7, 5.4]
    //   ];
    //   loadChart(this.chart, yData, xData, yearList);
    // }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.panel
  height 100%
  font-size .06rem

.content
  height 100%
  position relative

.flex
  display flex
  justify-content center
.num
  font-size 0.12rem

.chart-box
  width 100%
  height 100%
  position relative
  .tab-box
    position absolute
    top 10px
    right 0
    z-index 999
    .tab-item
      color #fff
      font-size 10px
      padding-left 13px
      margin-right 10px
      position relative
      cursor pointer
      &:before
        content ' '
        // width 6px
        // height 6px
        width 12px
        height 12px
        border-radius 50%
        background #fff
        position absolute
        left 0
        top 50%
        transform translateY(-50%)
    .active
      color #0e9cff
      &:before
        background #0e9cff
</style>
